<template>
    <div>
        <div class="page-title">
            <h1>
                {{ "adminTopicTitle" | trans }}
            </h1>
        </div>
        <div style="width: 50%;">
            <topic-admin></topic-admin>
        </div>
    </div>
</template>

<script>
import Vue from "vue";
import Component from "vue-class-component";
import TopicAdmin from "@/components/admin/TopicAdmin.vue";

const components = {
    TopicAdmin,
};

@Component({ components })
export default class Topic extends Vue {

}
</script>